import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-policy-dialog',
  templateUrl: './confirm-policy-dialog.component.html',
  styleUrls: ['./confirm-policy-dialog.component.scss']
})
export class ConfirmPolicyDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
